module.exports = __webpack_public_path__ + "img/stick_activites_kite_surf.29f50987.svg";